// Claims — one page for the billing work and for what it is owed.
//
// Two sidebar entries used to split one workflow: "HH Service Billing" was
// where runs were built and filed, and "Gen Claims Tracker" was a read-only
// view of the same lines with its own, wrong, status vocabulary. They are two
// tabs of the same page now. Runs is billing/BillingRuns; Receivables is the
// tracker rebuilt on lib/receivables.js, with a place to record a claim filed
// outside CAERA. The old routes redirect here.
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import BillingRuns from './billing/BillingRuns';
import Receivables from '../../components/finance/Receivables';

const TABS = [
  { key: 'runs',        label: 'Runs',        desc: 'Build, check and file' },
  { key: 'receivables', label: 'Receivables', desc: 'Aging, denials, every claim' },
];

export default function Claims() {
  const [params, setParams] = useSearchParams();
  const { runId } = useParams();
  // A run's own address always shows the Runs tab.
  const tab = !runId && TABS.some(t => t.key === params.get('tab')) ? params.get('tab') : 'runs';
  const navigate = useNavigate();
  const select = (key) => {
    if (runId) { if (key !== 'runs') navigate(`/finance/claims?tab=${key}`); return; }
    setParams(prev => {
      const n = new URLSearchParams(prev);
      key === 'runs' ? n.delete('tab') : n.set('tab', key);
      return n;
    });
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap', marginBottom: 14 }}>
        <div>
          <div style={{ fontSize: 11, color: 'var(--text3)', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 4 }}>Finance</div>
          <h2 style={{ margin: 0, fontSize: 20, fontWeight: 600, color: 'var(--text)' }}>Claims</h2>
        </div>
        <div role="tablist" style={{ display: 'flex', gap: 4, borderBottom: '0.5px solid var(--border)' }}>
          {TABS.map(t => (
            <button key={t.key} role="tab" aria-selected={tab === t.key} onClick={() => select(t.key)} title={t.desc}
              style={{ padding: '8px 14px', fontSize: 13, fontWeight: tab === t.key ? 600 : 500, fontFamily: 'inherit', cursor: 'pointer',
                       background: 'none', border: 'none', borderBottom: `2px solid ${tab === t.key ? 'var(--accent)' : 'transparent'}`,
                       color: tab === t.key ? 'var(--text)' : 'var(--text3)', marginBottom: -1 }}>
              {t.label}
            </button>
          ))}
        </div>
      </div>
      {tab === 'runs' ? <BillingRuns /> : <Receivables />}
    </div>
  );
}
